class FadeInOnScroll {
  constructor() {
    console.log("FadeInScroll")
    this.fadeElements = document.querySelectorAll(".fade-in-scroll")
    this.events()
    this.displayOnScroll() // Check position on initialization
  }

  // events
  events() {
    window.addEventListener("scroll", () => this.displayOnScroll())
  }

  // methods

  isElementInViewport(el) {
    const rect = el.getBoundingClientRect()
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  }

  displayOnScroll() {
    this.fadeElements.forEach((element) => {
      if (this.isElementInViewport(element)) {
        element.classList.add("visible")
      }
    })
  }
}

export default FadeInOnScroll
